"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAncestorBlockArray = (block, ancestors = []) => {
    if (!block.parentBlock) {
        return ancestors;
    }
    return exports.getAncestorBlockArray(block.parentBlock, [...ancestors, block]);
};
//# sourceMappingURL=getAncestorBlockArray.js.map